<template>
  <v-expansion-panels :multiple="true" v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header class="blue--text headline">Audience</v-expansion-panel-header>
      <v-expansion-panel-content>
        <ul>
          <li class="ma-1" v-for="(tag, index) in doc.audience" :key="index">
            <span class="pr-2">{{ tag.title }}</span>
          </li>
        </ul>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="">
      <v-expansion-panel-header class="green--text headline">Features</v-expansion-panel-header>
      <v-expansion-panel-content>
        <ul>
          <li class="ma-1" v-for="(tag, index) in doc.features" :key="index">
            <span class="pr-2">{{ tag.title }}</span>
          </li>
        </ul>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="">
      <v-expansion-panel-header class="deep-orange--text headline">Benefits</v-expansion-panel-header>
      <v-expansion-panel-content>
        <ul>
          <li class="ma-1" v-for="(tag, index) in doc.benefits" :key="index">
            <span class="pr-2">{{ tag.title }}</span>
          </li>
        </ul>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="">
      <v-expansion-panel-header class="pink--text headline">Evidence</v-expansion-panel-header>
      <v-expansion-panel-content>
        <ul>
          <li class="ma-1" v-for="(tag, index) in doc.reasons" :key="index">
            <span class="pr-2">{{ tag.title }}</span>
          </li>
        </ul>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

</template>

<script>
// @ is an alias to /src
export default {
  name: "PropositionSide",
  props: {
    doc: Object,
  },
  data() {
    return {
      panel: [0, 1, 2, 3],
    };
  },
};
</script>
